import React, { useState, useEffect } from 'react';
import CrmComercialesApp from './apps/CrmComercialesApp';
// Sistema de diseño de la suite: los mismos tokens y el mismo gradiente de marca
// que usa el portal, para que el modal de recuperación no desentone.
import { C, GRAD } from './ui/theme.js';

const SUPABASE_URL = 'https://zkznupgyaorojxpydlly.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inprem51cGd5YW9yb2p4cHlkbGx5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYwMjA5NTMsImV4cCI6MjA4MTU5Njk1M30.gKCpGxBeOCaaCRm10qQ_YpxXwTZQGbtTREsWrUG2RFY';

const RecoveryModal = ({ accessToken, onClose }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    if (newPassword.length < 6) { setMessage('error:Minimo 6 caracteres'); return; }
    if (newPassword !== confirmPassword) { setMessage('error:Las contrasenas no coinciden'); return; }
    setLoading(true);
    try {
      const res = await fetch(SUPABASE_URL + '/auth/v1/user', {
        method: 'PUT',
        headers: {
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': 'Bearer ' + accessToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password: newPassword })
      });
      if (res.ok) {
        setMessage('success:Contrasena actualizada. Ya puedes iniciar sesion.');
        setTimeout(() => onClose(), 2500);
      } else {
        const err = await res.json();
        setMessage('error:' + (err.message || 'Error. El enlace puede haber expirado.'));
      }
    } catch { setMessage('error:Error de conexion.'); }
    setLoading(false);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,28,43,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999, padding: '16px' }}>
      <div style={{ background: 'white', borderRadius: 14, padding: '28px', maxWidth: '360px', width: '100%', boxShadow: '0 20px 60px rgba(15,42,70,0.35)' }}>
        <div style={{ textAlign: 'center', marginBottom: '18px' }}>
          <div style={{ fontSize: '36px', marginBottom: '8px' }}>🔐</div>
          <h2 style={{ margin: '0 0 6px 0', fontSize: '19px', fontWeight: 800, letterSpacing: '-0.2px', color: C.ink }}>Nueva contraseña</h2>
          <p style={{ margin: 0, color: C.muted, fontSize: '12.5px' }}>Introduce tu nueva contraseña para restablecer el acceso.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '10px', fontWeight: 800, letterSpacing: '0.5px', textTransform: 'uppercase', color: C.muted }}>Nueva contraseña</label>
            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)}
              placeholder="Minimo 6 caracteres" required autoFocus
              style={{ width: '100%', padding: '9px 12px', borderRadius: 10, border: `1.5px solid ${C.line}`, fontSize: '13.5px', fontFamily: 'inherit', color: C.ink, boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '10px', fontWeight: 800, letterSpacing: '0.5px', textTransform: 'uppercase', color: C.muted }}>Confirmar contraseña</label>
            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Repite la contrasena" required
              style={{ width: '100%', padding: '9px 12px', borderRadius: 10, border: `1.5px solid ${C.line}`, fontSize: '13.5px', fontFamily: 'inherit', color: C.ink, boxSizing: 'border-box' }} />
          </div>
          {message && (
            <div style={{ padding: '10px 12px', borderRadius: 10, marginBottom: '14px', fontSize: '12.5px', fontWeight: 700,
              background: message.startsWith('success:') ? `${C.verde}14` : `${C.rojo}14`,
              border: '1px solid ' + (message.startsWith('success:') ? `${C.verde}44` : `${C.rojo}44`),
              color: message.startsWith('success:') ? C.verde : C.rojo }}>
              {message.replace(/^(success:|error:)/, '')}
            </div>
          )}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '11px', borderRadius: 10, border: 'none', background: loading ? C.faint : C.brand, boxShadow: loading ? 'none' : '0 3px 10px rgba(0,81,135,.28)', color: 'white', fontWeight: 800, fontSize: '13px', fontFamily: 'inherit', cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Guardando...' : 'Guardar contrasena'}
          </button>
        </form>
      </div>
    </div>
  );
};

function App() {
  const [recoveryToken, setRecoveryToken] = useState(null);
  const [recovering, setRecovering] = useState(false);

  useEffect(() => {
    const detectRecovery = async () => {
      const hash = window.location.hash;
      if (!hash || hash.length < 5) return;
      const params = new URLSearchParams(hash.substring(1));

      // Formato nuevo (template personalizado): #recovery=TOKEN_HASH
      const tokenHash = params.get('recovery');
      if (tokenHash) {
        setRecovering(true);
        window.history.replaceState(null, '', window.location.pathname);
        try {
          const res = await fetch(SUPABASE_URL + '/auth/v1/verify', {
            method: 'POST',
            headers: { 'apikey': SUPABASE_ANON_KEY, 'Content-Type': 'application/json' },
            body: JSON.stringify({ token_hash: tokenHash, type: 'recovery' })
          });
          if (res.ok) {
            const data = await res.json();
            if (data.access_token) setRecoveryToken(data.access_token);
          }
        } catch (e) {}
        setRecovering(false);
        return;
      }

      // Formato legacy: #access_token=xxx&type=recovery
      const accessToken = params.get('access_token');
      const type = params.get('type');
      if (accessToken && type === 'recovery') {
        window.history.replaceState(null, '', window.location.pathname);
        setRecoveryToken(accessToken);
      }
    };
    detectRecovery();
  }, []);

  if (recovering) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: C.bg, padding: '16px' }}>
        {/* Espera con el esqueleto del sistema en vez de una pantalla en blanco */}
        <div style={{ width: '100%', maxWidth: 360, textAlign: 'center' }}>
          <div style={{ fontSize: '30px', marginBottom: '12px' }}>🔐</div>
          <p style={{ fontSize: '13px', fontWeight: 800, color: C.ink, margin: '0 0 14px' }}>Verificando enlace...</p>
          <div className="fg-shimmer" style={{ height: 38, borderRadius: 12, marginBottom: 10 }} />
          <div className="fg-shimmer" style={{ height: 38, borderRadius: 12, marginBottom: 10 }} />
          <div className="fg-shimmer" style={{ height: 40, borderRadius: 12 }} />
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      {recoveryToken && <RecoveryModal accessToken={recoveryToken} onClose={() => setRecoveryToken(null)} />}
      <CrmComercialesApp />
    </React.Fragment>
  );
}

export default App;
